<template lang="pug">
  .modal-content
    .modal-header
      h5#exampleModalLongTitle.modal-title
        span.m-r-5 {{ $t('preview') }}
        .form-check.form-check-inline(v-for="mode in ['horizontalDiff', 'verticalDiff', 'slider']")
          label
            input.form-check-input(type="radio" v-bind:value="mode" v-model="compareMode")
            | {{ $t(mode) }}

      button.close(type="button" data-dismiss="modal" aria-label="Close")
        span(aria-hidden="true") ×
    .modal-body(v-if="preview && preview.resource")
      template(v-if="compareMode == 'horizontalDiff'")
        p.text-center {{ $t('defferenceDesc') }}
        table.table.table-bordered.text-center.compare-table
          thead
            tr
              th {{ origLabel }}
              th {{ $t('difference') }}
              th {{ simulationLabel }}
          tbody
            tr
              td(width="33%")
                a(v-bind:href="origImageUrl" target="_blank")
                  img.img-fluid(v-bind:src="origImageUrl")
              td(width="33%")
                .difference
                  img.img-fluid(v-bind:src="origImageUrl")
                  img.img-fluid.overlay(v-bind:src="simulationImageUrl")
              td(width="33%")
                a(v-bind:href="simulationImageUrl" target="_blank")
                  img.img-fluid(v-bind:src="simulationImageUrl")
      template(v-if="compareMode == 'verticalDiff'")
        p.text-center {{ $t('defferenceDesc') }}
        table.table.table-bordered.text-center.compare-table.compare-vertical
          tbody
            tr
              th {{ origLabel }}
              td
                a(v-bind:href="origImageUrl" target="_blank")
                  img.img-fluid(v-bind:src="origImageUrl")
            tr
              th {{ $t('difference') }}
              td
                .difference
                  img.img-fluid(v-bind:src="origImageUrl")
                  img.img-fluid.overlay(v-bind:src="simulationImageUrl")
            tr
              th {{ simulationLabel }}
              td
                a(v-bind:href="simulationImageUrl" target="_blank")
                  img.img-fluid(v-bind:src="simulationImageUrl")
      template(v-if="compareMode == 'slider'")
        .before-after-slider.text-center
          div {{ $t('sliderDesc') }}
          p
            strong.m-r-5 {{ origLabel }}
            | &lt; &gt;
            strong.m-l-5 {{ simulationLabel }}
          BeforeAfter(
            v-bind:key="beforeAfterKey"
            v-bind:afterimage="origImageUrl"
            v-bind:afteralt="origLabel"
            v-bind:beforeimage="simulationImageUrl"
            v-bind:beforealt="simulationLabel"
          )
          //- image-compare(v-bind:before="simulationImageUrl" v-bind:after="origImageUrl")

</template>

<style lang="scss" scoped>
  table.compare-table {
    width: auto;
    margin: auto;
    td {
      padding: 0px;
      text-align: left;
      overflow: hidden;
    }
    .difference {
      position: relative;
      .overlay {
        position: absolute;
        top: 0px;
        left: 0px;
        mix-blend-mode: difference;
      }
    }
  }
  table.compare-vertical {
    th {
      white-space: nowrap;
      vertical-align: middle;
    }
  }
  .before-after-slider {
    text-align: center;
    section {
      display: inline-block;
    }
  }
</style>

<i18n>
{
  "ja": {
    "preview": "比較プレビュー",
    "close": "閉じる",
    "difference": "差の絶対値",
    "defferenceDesc": "オリジナル画像と変換後の画像の差分を画像で表現したものです。2枚の画像に差分がない場合は黒一色になります。",
    "horizontalDiff": "画像の差分(横並び)",
    "verticalDiff": "画像の差分(縦並び)",
    "slider": "スライダー",
    "sliderDesc": "バーをスライドして変換前後の画像を比較できます。"
  }
}
</i18n>

<script>
import Path from 'path'
import Lib from '@/lib'

export default {
  props: {
    intent: String,
    preview: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      compareMode: window.localStorage.getItem('compareMode') || 'horizontalDiff',
      beforeAfterKey: 0,
    }
  },
  computed: {
    origLabel() {
      return this.translateSimulationLabel('orig')
    },
    simulationLabel() {
      return this.translateSimulationLabel()
    },
    origImageUrl() {
      return this.imageResourceUrl('orig')
    },
    simulationImageUrl() {
      return this.imageResourceUrl()
    },
  },
  methods: {
    translateSimulationLabel(simulation) {
      simulation = simulation || this.preview.simulation
      return this.$t(`simulations.${this.intent}.${simulation}`)
    },
    imageResourceUrl(simulation) {
      if (!this.preview.resource) return ''

      const resource = this.preview.resource
      simulation = simulation || this.preview.simulation
      const uri = Path.join(resource.s3KeyBase, resource.data[simulation].s3KeyPath);
      const url = new URL(uri, Lib.preset().resourceUrlBase);
      return url.href;
    },
  },
  watch: {
    compareMode() {
      window.localStorage.setItem('compareMode', this.compareMode)
    },
    preview: {
      handler() {
        // Force update
        this.beforeAfterKey++
      },
      deep: true,
    }
  }
}
</script>